type BezierParams = {
    x0: number;
    y0: number;
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    x3: number;
    y3: number;
};

type ParamsPoints = {
    toElement: any;
    fromElement: any;
    fromElementOffset?: { x: number; y: number };
    toElementOffset?: { x: number; y: number };
    time: number;
    pointOffsetX1?: number;
    pointOffsetY1?: number;
    pointOffsetX2?: number;
    pointOffsetY2?: number;
    ease?: string;
    onStart?: () => void;
    onChange?: () => void;
    onFinish?: () => void;
};

class GameUtilsCustom {
    static async playCurveMoveAnimation(element,
        {
            fromElement,
            fromElementOffset = { x: 0, y: 0 },
            toElement,
            toElementOffset = { x: 0, y: 0 },
            time,
            pointOffsetX1 = 0,
            pointOffsetY1 = 0,
            pointOffsetX2 = 0,
            pointOffsetY2 = 0,
            ease = 'linear',
            onStart = () => { },
            onChange = () => { },
            onFinish = () => { },
        }: ParamsPoints
    ): Promise<void> {
        return new Promise((resolve) => {
            const _tw = {
                x: 0,
                y: 0,
                progress: 0,
                timeLeft: time
            };
            const isElementParticles = !!element.emitter
            let tween = null;
            const ctx = this;

            game.on("game.render.ON_CHANGE_ORIENTATION", onChangeOrientation);

            function onChangeOrientation() {
                removeTween();
                resolve();
            }

            function startTween() {   
                // get global object positions
                const fromGlobalPos = fromElement.getGlobalPosition();
                const toGlobalPos = toElement.getGlobalPosition();

                // transform to local positions of the moved object
                const fromLocalPos = {
                    x: element.toLocal(fromGlobalPos).x + fromElementOffset.x,
                    y: element.toLocal(fromGlobalPos).y + fromElementOffset.y,
                };
                const toLocalPos = {
                    x: element.toLocal(toGlobalPos).x + toElementOffset.x,
                    y: element.toLocal(toGlobalPos).y + toElementOffset.y
                };

                _tw.x = fromLocalPos.x;
                _tw.y = fromLocalPos.y;
                _tw.progress = 0;
                _tw.timeLeft = time;

                if (isElementParticles) {
                    element.emitter.updateOwnerPos(_tw.x, _tw.y);
                } else {
                    element.options.position.x = _tw.x;
                    element.options.position.y = _tw.y;
                }

                tween = createjs.Tween.get(_tw,
                    {
                        onChange: () => {
                            onChange()

                            const paramsPoints =
                                ctx.getParamsPoints(
                                    {
                                        fromLocalPos,
                                        toLocalPos,
                                        pointOffsetX1,
                                        pointOffsetY1,
                                        pointOffsetX2,
                                        pointOffsetY2
                                    }
                                );
                            const position = ctx.getBezierPoint(
                                paramsPoints,
                                _tw.progress
                            );

                            if (isElementParticles) {
                                element.emitter.updateOwnerPos(position.x, position.y)
                            } else {
                                element.x = position.x;
                                element.y = position.y;
                                element.options.position.x = position.x;
                                element.options.position.y = position.y;
                            }
                        }
                    })
                    .call(onStart.bind(this, element))
                    .to(
                        {
                            x: toLocalPos.x,
                            y: toLocalPos.y,
                            progress: 1,
                            timeLeft: 0
                        },
                        time,
                        createjs.Ease[ease]
                    )
                    .wait(0)
                    .call(onFinish.bind(this, element))
                    .call(() => {
                        game.removeListener("game.render.ON_CHANGE_ORIENTATION", onChangeOrientation);
                        resolve();
                    });
            }

            function removeTween() {
                game.utils.removeCall(tween);
            }

            removeTween();
            startTween();
        });
    }

    static getBezierPoint(params: BezierParams, t: number) {
        const { x0, y0, x1, y1, x2, y2, x3, y3 } = params;
        const invT = 1 - t;
        const x = x0 * invT * invT * invT + 3 * x1 * t * invT * invT + 3 * x2 * t * t * invT + x3 * t * t * t;
        const y = y0 * invT * invT * invT + 3 * y1 * t * invT * invT + 3 * y2 * t * t * invT + y3 * t * t * t;
        return { x, y };
        //TODO: динамічна кількість точок(опционально)
    }

    static getParamsPoints(
        {
            fromLocalPos,
            toLocalPos,
            pointOffsetX1,
            pointOffsetY1,
            pointOffsetX2,
            pointOffsetY2
        }
    ) {
        const paramsPoints = {
            //start point
            x0: fromLocalPos.x,
            y0: fromLocalPos.y,
            //intermediate point
            x1: fromLocalPos.x + pointOffsetX1,
            y1: fromLocalPos.y + pointOffsetY1,
            //intermediate point
            x2: toLocalPos.x + pointOffsetX2,
            y2: toLocalPos.y + pointOffsetY2,
            //finish point
            x3: toLocalPos.x,
            y3: toLocalPos.y
        };

        return paramsPoints;
    }

}

export { GameUtilsCustom };